const ArmorUse = require('../ability_trees/ArmorUse.js');
const MeleeCombat = require('../ability_trees/MeleeCombat.js');
const Spirit = require('../ability_trees/Spirit.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const HeavyHelmet = require('../../game_items/equipment/helmet/HeavyHelmet.js');
const HeavyTorsoe = require('../../game_items/equipment/torsoe/HeavyTorsoe.js');
const HeavyBoots = require('../../game_items/equipment/boots/HeavyBoots.js');
const Hammer = require('../../game_items/equipment/weapon/Hammer.js');
const Shield = require('../../game_items/equipment/off_hand/Shield.js');

module.exports = {
  handle: 'paladin',
  getAbilityTrees: () => ([
    ArmorUse,
    MeleeCombat,
    Spirit,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 6,
    perception: 4,
    mana: 8,
    toughness: 8,
    strength: 9,
    willpower: 10,
    dexterity: 5,
  }),
  getDefaultAIConfig: () => (['tank', 'support', 'dps_close', 'interference', 'dps_ranged']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(HeavyHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(HeavyTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(HeavyBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Hammer, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Shield, 0, 0.1, true),
  }),
};
